module.exports = __webpack_public_path__ + "img/Infrastructure-1.56843fdd.png";